// extracted by mini-css-extract-plugin
export default {"page":"LoginPage_page__sxSq8","main":"LoginPage_main__ROIAS","error":"LoginPage_error__mntiQ","footer":"LoginPage_footer__Tlq0c"};